import * as React from "react";
import type { SVGProps } from "react";
const SvgVerticalIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    className="vertical_icon_svg__icon"
    viewBox="0 0 1024 1024"
    {...props}
  >
    <path
      fill="currentColor"
      d="M469.333 655.147v283.52a42.667 42.667 0 1 0 85.334 0v-283.52a149.419 149.419 0 0 0 0-286.294V85.333a42.667 42.667 0 1 0-85.334 0v283.52a149.419 149.419 0 0 0 0 286.294zM448 512a64 64 0 1 1 128 0 64 64 0 0 1-128 0z"
    />
  </svg>
);
export default SvgVerticalIcon;
